import React, { useContext, useEffect } from 'react';
import { Label, Checkbox, Link } from '@fluentui/react';

import { StepContainer } from 'components/common/steps/StepContainer';
import { StepProps } from 'components/deployment/Deployment';
import { stepStyles as styles } from 'components/steps/commonStyles';
import { Title } from 'components/common/Title';
import TranslationsContext from 'translations/TranslationsContext';
import translationKeys from 'translationKeys';
import { Trans } from 'react-i18next';

export const About = ({ checkCanGoNext }: StepProps) => {
	const { t } = useContext(TranslationsContext)!;
	const [termsConfirmed, setTerms] = React.useState(false);

	useEffect(() => {
		checkCanGoNext(termsConfirmed);
	}, [termsConfirmed]);

	return (
		<StepContainer>
			<div className={styles.root}>
				<Title id='form-title'>{t(translationKeys.About.Title.Content)}</Title>
				<p className={styles.formElement}>{t(translationKeys.About.Paragraph.First)}</p>
				<p className={styles.formElement}>{t(translationKeys.About.Paragraph.Second)}</p>
				<p className={styles.formElement}>{t(translationKeys.About.Paragraph.Third)}</p>

				<Label className={styles.consentLable} required>{t(translationKeys.About.Terms.Label)}</Label>
				<Checkbox id='termsId' required inputProps={{ 'aria-invalid': 'false' }} onChange={(e, checked) => setTerms(checked)} onRenderLabel={
					() => <label htmlFor='termsId'>{
						<Trans
							i18nKey={translationKeys.About.Terms.Acknowledgement}
							components={{
								terms: <Link underline={true} target='_blank' href='https://aka.ms/mc4n/installer/tos' />,
								privacy: <Link underline={true} target='_blank' href='https://go.microsoft.com/fwlink/?LinkId=521839' />
							}}
						/>}
					</label>} />
			</div>
		</StepContainer>
	);
};
